/* eslint-disable jira/naming/disallow-filenames */
/* eslint-disable jira/deprecations/no-rll-client-async-experiences */
import React from 'react';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';

// oxlint-disable-next-line typescript/no-explicit-any
export const LazyUserNotifications: LazyComponent<any> = lazyForPaint<any>(
	() =>
		import(
			/* webpackChunkName: "async-jira-eoc-user-notifications", jiraSpaEntry: "async-jira-eoc-user-notifications" */ '@jira/eoc__user-notifications/src/index.tsx'
		),
	{ ssr: false },
);

const LazyUserNotificationsPage = (): React.JSX.Element => (
	<LazyPage
		Page={LazyUserNotifications}
		pageId="async-eoc-user-notifications"
		shouldShowSpinner={false}
	/>
);

export default LazyUserNotificationsPage;
